module.exports = __webpack_public_path__ + "static/media/home-chargers-big-promise.82ea0d8a.svg";